import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SidePanel } from '../../components/SidePanel';
import type { ThemeScope } from '../../theme/presets';
import { ClassroomNameField } from './ClassroomNameField';
import { ThemeEditor } from './ThemeEditor';

/** Two themes: the website around the sheet, and the weekly timetable itself. */
export default function LooksPanel() {
  const [scope, setScope] = useState<ThemeScope>('site');
  return (
    <SidePanel title="Uiterlijk" description="Kies een voorinstelling of maak een eigen thema met je eigen rand en logo.">
      <ClassroomNameField />
      <Tabs value={scope} onValueChange={(value) => setScope(value as ThemeScope)}>
        <TabsList aria-label="Thema voor" className="grid h-auto w-full grid-cols-2">
          <TabsTrigger value="site" className="min-h-11">
            Website
          </TabsTrigger>
          <TabsTrigger value="planner" className="min-h-11">
            Weekrooster
          </TabsTrigger>
        </TabsList>
        <TabsContent value={scope} className="mt-3 flex flex-col gap-3">
          <p className="text-sm opacity-70">
            {scope === 'site' ? 'De website om het rooster heen.' : 'Het weekrooster zelf, ook op het bord en op papier.'}
          </p>
          {/* The key remounts the editor, which sends any change that is still waiting before the other theme opens. */}
          <ThemeEditor key={scope} scope={scope} />
        </TabsContent>
      </Tabs>
    </SidePanel>
  );
}
